export default {
  title: 'Report entrate',
  sections: {
    new_report: 'Nuovo report',
  },
  form: {
    period: {
      label: 'Periodo',
    },
  },
  buttons: {
    export: 'Esporta',
  },
  toasts: {
    failed_to_create_report: 'Creazione report non riuscita',
  },
};
